import type { BaseSpecies, Species } from '../types'

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ')
}

type AnySpecies = Species | BaseSpecies | null

export const sortSpecies = (sp1: AnySpecies, sp2: AnySpecies) => {
  if (!sp1 && !sp2) return 0
  if (!sp1) return -1
  if (!sp2) return 1
  const species1 = `${sp1.genus} ${sp1.epithet}`
  const species2 = `${sp2.genus} ${sp2.epithet}`
  if (species1 > species2) return 1
  if (species1 < species2) return -1
  return 0
}

export const booleanFilterTypeGuard = <T>(
  value: T | undefined | null,
): value is T => Boolean(value)

export const stringNotEmptyFilterTypeGuard = (
  value: string | undefined | null,
): value is string =>
  Boolean(value && typeof value === 'string' && value.length > 0)
